/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllocationPercentageTarget {
    getFixupPrototypeFunction() { return AllocationPercentageTarget.fixupPrototype; }

    static newInstance(model: Partial<AllocationPercentageTarget>): AllocationPercentageTarget {
        let obj = Object.assign(new AllocationPercentageTarget(), model);
        AllocationPercentageTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllocationPercentageTarget>): AllocationPercentageTarget {
        if (!model) return null;
        return AllocationPercentageTarget.newInstance(<AllocationPercentageTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllocationPercentageTarget) {
        if (!obj) return;

        models.AllocationPercentageTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllocationPercentageTarget): boolean {
        Object.setPrototypeOf(obj, AllocationPercentageTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
        if (this.target) {
            models.AllocationTarget.fixupPrototype(this.target);
        }
    }

    /**
     * Target to allocate the cost to
     */
    target: models.AllocationTarget;

    /**
     * Percentage of the cost to allocate to the target
     */
    percentage: number;

}
